import {RoadtripMapItem} from '../../../core/api/resources/roadtrip-map-item.resource';
import {MapService} from './map.service';

declare var mapkit: any;

export class IosMapService extends MapService {

  tokenEndpoint = 'https://token.unrestricted.eu/mk-token';
  map: any;

  clear(): void {
    // todo cleanup
  }

  drawRoadtripMarker(roadtrip: RoadtripMapItem): void {
    const stepPoint = new mapkit.Coordinate(Number(roadtrip.latitude), Number(roadtrip.longitude));
    const stepPointAnnotation = new mapkit.MarkerAnnotation(stepPoint);
    stepPointAnnotation.callout = {
      calloutElementForAnnotation: (annotation) => {
        const div = document.createElement('div');
        div.className = 'landmark';

        const title = div.appendChild(document.createElement('h1'));
        title.textContent = roadtrip.tripName;

        const section = div.appendChild(document.createElement('section'));

        const country = section.appendChild(document.createElement('p'));
        country.textContent = `${roadtrip.country}`;

        const link = section.appendChild(document.createElement('p'));
        const a = link.appendChild(document.createElement('a'));
        a.addEventListener('click', () => {
          this.router.navigate(['roadtrip-details'], {
            queryParams: {
              id: roadtrip.id
            }
          });
        });
        a.textContent = 'View trip details';

        return div;
      },

      calloutAnchorOffsetForAnnotation(annotation, element) {
        return new DOMPoint(-148, -78);
      },

      calloutAppearanceAnimationForAnnotation(annotation) {
        return 'scale-and-fadein .4s 0 1 normal cubic-bezier(0.4, 0, 0, 1.5)';
      }
    };
    stepPointAnnotation.color = '#FFA214';

    this.map.showItems([stepPointAnnotation]);
  }

  drawUserMarker(coords: { lat: number; lng: number }): void {
    const startPoint = new mapkit.Coordinate(coords.lat, coords.lng);
    const startPointAnnotation = new mapkit.MarkerAnnotation(startPoint);
    startPointAnnotation.color = '#14213D';

    this.map.showItems([startPointAnnotation]);
  }

  setMap(map: any): any {
    this.map = new mapkit.Map(map);
    this.map.showsZoomControl = true;
    this.map.showsPointsOfInterest = true;
    this.map.showsUserLocation = true;
    return this.map;
  }

  setCenter(lat: number, lng: number): void {
    this.map.region = new mapkit.CoordinateRegion(
      new mapkit.Coordinate(lat, lng),
      // Zoom level
      new mapkit.CoordinateSpan(0.1, 1.5)
    );
  }
}
